import { useTheme } from 'foundations-theming/utils';

export const useIsPillBorderRadius = (): boolean => {
  const theme = useTheme();
  // When a user changes their borderRadius to `pill`
  // we will convert all borderRadius tokens to `999999px` except token `0`
  return theme.borderRadius['100'] === '999999px';
};
